import parseBarcode from './parseBarcode'
import type { BarcodeInfo, TextResults } from './types'

export const parseTextResults = (textResults: TextResults): BarcodeInfo => {
    if (!textResults) {
        return {
            textResults: [],
        }
    }

    const code = textResults?.[0]?.barcodeText

    if (!code) {
        return {
            textResults: [],
        }
    }

    const parsed = parseBarcode(code)

    return {
        ...parsed,
        code,
        textResults,
    }
}

export default parseTextResults
